<template>
  <div class="row">
    <div class="col-md-12" v-if="gradingDefinitions.length > 0">
      <fieldset v-if="gradingLists.length > 0">
        <legend class="text-black">
          Grading
        </legend>
        <table class="ts-w-full">
          <thead>
            <th
              class="tw-whitespace-no-wrap"
              v-for="(grading, index) in gradingLists"
              :key="index"
            >
              {{ grading.definition_name_en }}
            </th>
          </thead>
          <tbody>
            <tr>
              <th v-for="(grading, index) in gradingLists" :key="index">
                {{ grading.grade }}
              </th>
            </tr>
            <tr>
              <th v-for="(grading, index) in gradingLists" :key="index">
                {{ grading.description }}
              </th>
            </tr>
          </tbody>
        </table>
      </fieldset>
      <fieldset class="mt-4" v-if="ratingLists.length > 0">
        <legend class="text-black">
          Rating
        </legend>
        <table class="ts-w-full">
          <thead>
            <th
              class="tw-whitespace-no-wrap"
              v-for="(grading, index) in ratingLists"
              :key="index"
            >
              {{ grading.definition_name_en }}
            </th>
          </thead>
          <tbody>
            <tr>
              <td v-for="(grading, index) in ratingLists" :key="index">
                {{ grading.description }}
              </td>
            </tr>
            <tr>
              <th v-for="(grading, index) in ratingLists" :key="index">
                {{ grading.grade }}
              </th>
            </tr>
          </tbody>
        </table>
      </fieldset>
    </div>
  </div>
</template>
<script>
export default {
  name: 'gradingDefinition',
  props: ['value', 'gradingDefinitions'],
  data() {
    return {
      model: {}
    }
  },
  computed: {
    gradingLists() {
      return this.gradingDefinitions.filter(
        el => el.definition_type == 'Grading' && el.acp_id == this.model.acp_id
      )
    },
    ratingLists() {
      return this.gradingDefinitions.filter(
        el => el.definition_type == 'Rating' && el.acp_id == this.model.acp_id
      )
    }
  },
  created () {
    this.model = this.value
  },
}
</script>

<style lang="css" scoped>
table {
  border: 1px solid #d8d8d8;
}
table th {
  text-align: center;
  background-color: #f7fafc;
  border-right: 1px solid #d8d8d8;
  border-top: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
  padding: 5px 0 5px 0;
}
table td {
  border-top: 1px solid #d8d8d8;
  border-right: 1px solid #d8d8d8;
  background-color: #ffffff;
  min-height: 50px;
  vertical-align: top;
  text-align: center;
  padding: 5px;
}
</style>
